import { render, staticRenderFns } from "./GroupSessionParticipationNotification.vue?vue&type=template&id=0b62d946&scoped=true&"
import script from "./GroupSessionParticipationNotification.vue?vue&type=script&lang=js&"
export * from "./GroupSessionParticipationNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b62d946",
  null
  
)

export default component.exports